var _defs, _path, _path2, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSynching(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 740.76 609.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".synching1{fill:#fff;}.synching2{fill:#3257a4;isolation:isolate;opacity:.6;}.synching3{fill:blue;}.synching4{fill:#e20613;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "synching2",
    d: "m732.78,393.9c-7.9-7.3-195.6-179.4-362.4-179.4S15.88,386.5,7.98,393.9c-10.1,9.4-10.7,25.2-1.3,35.3.4.4.8.9,1.3,1.3,7.9,7.3,195.6,179.4,362.4,179.4s354.5-172,362.4-179.4c10.1-9.4,10.7-25.2,1.3-35.3-.4-.5-.9-.9-1.3-1.3Zm-523.6,117.8c-63-33.3-117.7-75.7-146.2-99.5,28.6-23.8,83.2-66.2,146.2-99.5-37.7,61-37.7,138.1,0,199h0Zm161.1,40.1c-77,0-139.6-62.6-139.6-139.6s62.6-139.6,139.6-139.6,139.6,62.6,139.6,139.6-62.5,139.6-139.6,139.6h0Zm161.2-40.1c37.7-61,37.7-138,0-199,63,33.3,117.7,75.7,146.2,99.5-28.5,23.8-83.2,66.2-146.2,99.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "synching2",
    d: "m370.38,346.1c-36.5,0-66.1,29.6-66,66.1,0,36.5,29.6,66.1,66.1,66,36.5,0,66-29.6,66-66.1-.1-36.4-29.7-65.9-66.1-66Zm0,82.3c-8.9,0-16.2-7.3-16.2-16.2s7.3-16.2,16.2-16.2,16.2,7.3,16.2,16.2-7.3,16.2-16.2,16.2Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "synching3",
    cx: 222.38,
    cy: 67.4,
    r: 67.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "synching4",
    cx: 518.28,
    cy: 67.4,
    r: 67.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "synching1",
    cx: 370.38,
    cy: 67.4,
    r: 67.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynching);
export default __webpack_public_path__ + "static/media/Synching.41b9f44a6ac25eb38a7885470492dea1.svg";
export { ForwardRef as ReactComponent };